// extracted by mini-css-extract-plugin
export default {"main":"Landing_main__3XLap"};